import React from 'react'
import { ColumnHeightOutlined } from '@ant-design/icons'

import { LntIconButton } from '@app/components/base'
import { BUTTON_TYPE, SIZE } from '@app/constants'

import variables from '@app/theme/variables'

import type { TableSizeButtonProps } from './types'

export const TableSizeButton: React.FC<TableSizeButtonProps> = ({ active, ...iconButtonProps }) => {
  const textColor = active ? variables.brandBlue : undefined

  return (
    <LntIconButton
      { ...iconButtonProps }
      textColor={ textColor }
      type={ BUTTON_TYPE.text }
      size={ SIZE.small }
      icon={ <ColumnHeightOutlined /> }
    />
  )
}
